import React from 'react';

/**
 * SUIVI DE STAGE — la modale du module.
 *
 * ⚠️ Règle 6 du protocole : JAMAIS `alert`, `confirm` ni `prompt`. Deux raisons,
 * et la seconde est la vraie : une boîte du navigateur n'a ni la charte ni la
 * langue de l'application, et surtout elle BLOQUE le fil d'exécution — ce qui,
 * dans un écran qui vient d'enregistrer, fige aussi la mise à jour en cours.
 *
 * La convention du projet veut DEUX temps : un récapitulatif AVANT l'acte
 * (« voici ce qui va se passer »), et une confirmation APRÈS (« voici ce qui
 * s'est passé »). Un geste destructeur annoncé par un simple « Êtes-vous sûr ? »
 * ne dit pas ce qu'on détruit ; c'est précisément là que les erreurs se prennent.
 */
// Lot L1a : `validerDesactive` — le bouton Valider reste grisé tant que la saisie est incomplète (fenêtres « Nouveau processus »).
function StageModale({ titre, icone, ton = 'neutre', enCours = false, children, classe = '',
                       libelleValider, onValider, libelleAnnuler = 'Annuler', onFermer, validerDesactive = false }) {
    const couleurs = {
        neutre: '#16a34a',
        danger: '#b91c1c',
        succes: '#15803d'
    };

    return (
        <div
            className="stg-modale-fond"
            role="dialog"
            aria-modal="true"
            aria-label={titre}
            // Le clic sur le fond referme, comme partout dans l'application — mais
            // JAMAIS pendant qu'une écriture est en cours : refermer à ce moment
            // laisserait l'utilisateur sans le résultat de son propre geste.
            onClick={() => { if (!enCours) onFermer(); }}
        >
            <div className={'stg-modale' + (classe ? ' ' + classe : '')} onClick={(e) => e.stopPropagation()}>
                <div className="stg-modale-header" style={{ color: couleurs[ton] || couleurs.neutre }}>
                    <i className={'fa-solid ' + (icone || 'fa-circle-info')} />
                    <span>{titre}</span>
                </div>
                <div className="stg-modale-body">{children}</div>
                <div className="stg-modale-pied">
                    <button type="button" className="btn btn-outline btn-sm" onClick={onFermer} disabled={enCours}>
                        {onValider ? libelleAnnuler : 'Fermer'}
                    </button>
                    {onValider && (
                        <button
                            type="button"
                            className={'btn btn-sm ' + (ton === 'danger' ? 'btn-danger' : 'btn-green')}
                            onClick={onValider}
                            disabled={enCours || validerDesactive}
                        >
                            {enCours
                                ? <><i className="fa-solid fa-circle-notch stg-tourne" /> En cours…</>
                                : <><i className="fa-solid fa-check" /> {libelleValider}</>}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default StageModale;
